import axios from 'axios'

export default {
  get (id) {
    return axios.get('category/' + id)
  },
  add (category) {
    return axios.post('category', category)
  },
  save (category) {
    return axios.put('category/' + category.id, category)
  },
  delete (category) {
    return axios.delete('category/' + category.id)
  },
  getAllByEvent (token) {
    return axios.get('event/' + token + '/category')
  },
}
